function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { bbox, rbox, inside } from '../types/Box.js';
import { ctm, screenCTM } from '../types/Matrix.js';
import { extend, getClass, makeInstance, register, root } from '../utils/adopter.js';
import { globals } from '../utils/window.js';
import { point } from '../types/Point.js';
import { proportionalSize, writeDataToDom } from '../utils/utils.js';
import { reference } from '../modules/core/regex.js';
import Dom from './Dom.js';
import List from '../types/List.js';
import SVGNumber from '../types/SVGNumber.js';
var Element = /*#__PURE__*/ function(Dom) {
    "use strict";
    _inherits(Element, Dom);
    function Element(node, attrs) {
        _class_call_check(this, Element);
        var _this;
        _this = _call_super(this, Element, [
            node,
            attrs
        ]);
        // initialize data object
        _this.dom = {};
        // create circular reference
        _this.node.instance = _this;
        if (node.hasAttribute('data-svgjs') || node.hasAttribute('svgjs:data')) {
            var _JSON_parse, _ref;
            // pull svgjs data from the dom (getAttributeNS doesn't work in html5)
            _this.setData((_ref = (_JSON_parse = JSON.parse(node.getAttribute('data-svgjs'))) !== null && _JSON_parse !== void 0 ? _JSON_parse : JSON.parse(node.getAttribute('svgjs:data'))) !== null && _ref !== void 0 ? _ref : {});
        }
        return _this;
    }
    _create_class(Element, [
        {
            // Move element by its center
            key: "center",
            value: function center(x, y) {
                return this.cx(x).cy(y);
            }
        },
        {
            // Move by center over x-axis
            key: "cx",
            value: function cx(x) {
                return x == null ? this.x() + this.width() / 2 : this.x(x - this.width() / 2);
            }
        },
        {
            // Move by center over y-axis
            key: "cy",
            value: function cy(y) {
                return y == null ? this.y() + this.height() / 2 : this.y(y - this.height() / 2);
            }
        },
        {
            // Get defs
            key: "defs",
            value: function defs() {
                var root = this.root();
                return root && root.defs();
            }
        },
        {
            // Relative move over x and y axes
            key: "dmove",
            value: function dmove(x, y) {
                return this.dx(x).dy(y);
            }
        },
        {
            // Relative move over x axis
            key: "dx",
            value: function dx() {
                var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return this.x(new SVGNumber(x).plus(this.x()));
            }
        },
        {
            // Relative move over y axis
            key: "dy",
            value: function dy() {
                var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return this.y(new SVGNumber(y).plus(this.y()));
            }
        },
        {
            key: "getEventHolder",
            value: function getEventHolder() {
                return this;
            }
        },
        {
            // Set height of element
            key: "height",
            value: function height(height) {
                return this.attr('height', height);
            }
        },
        {
            // Move element to given x and y values
            key: "move",
            value: function move(x, y) {
                return this.x(x).y(y);
            }
        },
        {
            // return array of all ancestors of given type up to the root svg
            key: "parents",
            value: function parents() {
                var until = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.root();
                var isSelector = typeof until === 'string';
                if (!isSelector) {
                    until = makeInstance(until);
                }
                var parents = new List();
                var parent = this;
                while((parent = parent.parent()) && parent.node !== globals.document && parent.nodeName !== '#document-fragment'){
                    parents.push(parent);
                    if (!isSelector && parent.node === until.node) {
                        break;
                    }
                    if (isSelector && parent.matches(until)) {
                        break;
                    }
                    if (parent.node === this.root().node) {
                        // We worked our way to the root and didn't match `until`
                        return null;
                    }
                }
                return parents;
            }
        },
        {
            // Get referenced element form attribute value
            key: "reference",
            value: function reference1(attr) {
                attr = this.attr(attr);
                if (!attr) return null;
                var m = (attr + '').match(reference);
                return m ? makeInstance(m[1]) : null;
            }
        },
        {
            // Get parent document
            key: "root",
            value: function root1() {
                var p = this.parent(getClass(root));
                return p && p.root();
            }
        },
        {
            // set given data to the elements data property
            key: "setData",
            value: function setData(o) {
                this.dom = o;
                return this;
            }
        },
        {
            // Set element size to given width and height
            key: "size",
            value: function size(width, height) {
                var p = proportionalSize(this, width, height);
                return this.width(new SVGNumber(p.width)).height(new SVGNumber(p.height));
            }
        },
        {
            // Set width of element
            key: "width",
            value: function width(width) {
                return this.attr('width', width);
            }
        },
        {
            // write svgjs data to the dom
            key: "writeDataToDom",
            value: function writeDataToDom1() {
                writeDataToDom(this, this.dom);
                return _get(_get_prototype_of(Element.prototype), "writeDataToDom", this).call(this);
            }
        },
        {
            // Move over x-axis
            key: "x",
            value: function x(x) {
                return this.attr('x', x);
            }
        },
        {
            // Move over y-axis
            key: "y",
            value: function y(y) {
                return this.attr('y', y);
            }
        }
    ]);
    return Element;
}(Dom);
export { Element as default };
extend(Element, {
    bbox: bbox,
    rbox: rbox,
    inside: inside,
    point: point,
    ctm: ctm,
    screenCTM: screenCTM
});
register(Element, 'Element');
